import React, { useEffect, useState, useRef } from 'react';
import { string } from 'prop-types';
import FreestarAdSlot from '@freestar/pubfig-adslot-react-component';
import { useDispatch, useSelector } from 'react-redux';
import ClientSideLoggerAction from '../../actions/ClientLoggerAction';

const FreestarAd = ({ automationId, channel, className, placementName, pageType }) => {
    const [loadAd, setLoadAd] = useState(false);
    const eventHandler = () => {
        setLoadAd(true);
    };

    const injectFreestarStylesheet = () => {
        const link = document?.createElement('link');
        link.id = 'freestarCSS';
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = 'https://a.pub.network/jcpenney-com/cls.css';
        document?.head?.appendChild(link);
        return link;
    };

    useEffect(() => {
        document?.addEventListener('pageReadyForAdLoad', eventHandler);

        let link = document?.querySelector('#freestarCSS');
        if (!link) {
            link = injectFreestarStylesheet();
        }

        return () => {
            document?.querySelector('#freestarCSS') && document?.head?.removeChild(link);
            document?.removeEventListener('pageReadyForAdLoad', eventHandler);
        };
    }, []);

    const {
        featureFlags: { enableFreestarAdLogging = false } = {},
        preferences: { freestarAdSizes = {} },
    } = useSelector((state) => state.context);
    const dispatch = useDispatch();
    const adSlotRef = useRef();
    const adSlotObserverOptions = {
        attributes: false,
        characterData: false,
        childList: true,
        subtree: true,
    };

    /* istanbul ignore next */
    const onAdSlotObserved = () => {
        const adSlot = document.querySelector(`#${placementName} iframe`);

        if (!adSlot) return;

        const { width, height } = adSlot.getBoundingClientRect();

        if (!freestarAdSizes[placementName].includes(`${width}x${height}`)) {
            console.log(
                `FreestarAd size is incorrect (placementName: ${placementName}, width: ${width}, height: ${height})`
            );

            dispatch(
                ClientSideLoggerAction.logError(
                    `FreestarAd size is incorrect (placementName: ${placementName}, width: ${width}, height: ${height})`,
                    `actionName: freestarRogueAd | pageType: ${pageType} | placementName: ${placementName} | imageSrc: ${imageSrc} | width: ${width} | height: ${height} | user-agent:${window?.navigator?.userAgent}`
                )
            );
        }
    };

    /* istanbul ignore next */
    useEffect(() => {
        if (enableFreestarAdLogging && adSlotRef.current) {
            const adSlotObserver = new MutationObserver(onAdSlotObserved);
            adSlotObserver.observe(adSlotRef.current, adSlotObserverOptions);
            return () => adSlotObserver.disconnect();
        }
    }, [adSlotRef]);

    const publisher = 'jcpenney-com';
    const adChannel = channel || undefined; // this is only required for category and department pages

    return loadAd ? (
        <div data-automation-id={automationId} className={className} ref={adSlotRef}>
            <FreestarAdSlot
                publisher={publisher}
                placementName={placementName}
                channel={adChannel}
            />
        </div>
    ) : null;
};

FreestarAd.defaultProps = {
    automationId: '',
    channel: '',
    className: '',
    pageType: '',
};

FreestarAd.propTypes = {
    placementName: string.isRequired,
    automationId: string,
    channel: string,
    className: string,
    pageType: string,
};

export default FreestarAd;
